import gql from 'graphql-tag';

export default gql`
  mutation updateOrderLessonMutation($lessons: [UpdateOrderLessonInput]) {
    updateOrderLessonMutation(lessons: $lessons) {
      record {
        status
      }
    }
  }
`;
